import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrPairCertificatePayload } from 'api/actions/hr-pair-certificate/hr-pair-certificate-payload';
import { HrPairCertificatePathParameters } from 'api/actions/hr-pair-certificate/hr-pair-certificate-path-parameters';
import { HrPairCertificateResponse } from 'api/actions/hr-pair-certificate/hr-pair-certificate-response';

type HrPairCertificateQueryParameters = Record<string, any>;

/**
 * The path of the HrPairCertificate action.
 */
export const hrPairCertificateActionPath = new SweetPath<keyof HrPairCertificatePathParameters>(
  '/api/hr/terms/{termId}/certificate',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrPairCertificate actions.
 */
export default function createHrPairCertificateAction(axios: AxiosInstance) {
  return function hrPairCertificateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrPairCertificatePathParameters;
    query?: HrPairCertificateQueryParameters;
    payload: HrPairCertificatePayload;
  }) {
    const path = hrPairCertificateActionPath.insert(parameters);

    return axios.request<HrPairCertificateResponse, HrPairCertificateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
